/*
 * StudentFilter Messages
 *
 * This contains all the text for the StudentFilter component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    defaultOptionStudentLastName: {
        id: 'student-roll.container.studentRoll.defaultOptionStudentLastName',
        defaultMessage: 'All surnames'
    },
    defaultOptionStudentYearGroup: {
        id: 'student-roll.container.studentRoll.defaultOptionStudentYearGroup',
        defaultMessage: 'All years'
    },
    defaultOptionStudentClass: {
        id: 'student-roll.container.studentRoll.defaultOptionStudentClass',
        defaultMessage: 'All classes'
    },
    UnassignedStudent: {
        id: 'student-roll.container.studentRoll.UnassignedStudent',
        defaultMessage: 'Unassigned students'
    },
    assignedStudents: {
        id: 'student-roll.container.studentRoll.assignedStudents',
        defaultMessage: 'Assigned Students'
    },
    errorOnDeletingAssignedStudents: {
        id: 'student-roll.container.studentRoll.errorOnDeletingAssignedStudents',
        defaultMessage: 'Error - some selected students are assigned to classes and will not be deleted'
    },
    deleteStudentSuccess: {
        id: 'student-roll.container.studentRoll.deleteStudentSuccess',
        defaultMessage: '{deletedStudentsCount} student(s) removed from the school roll'
    },
    partialDeleteMessage1: {
        id: 'student-roll.container.studentRoll.partialDeleteMessage1',
        defaultMessage: 'Error - some selected students are assigned to classes and will not be deleted -'
    },
    partialDeleteMessage2: {
        id: 'student-roll.container.studentRoll.partialDeleteMessage2',
        defaultMessage: 'Student(s) have been removed from the school roll'
    }
});



// WEBPACK FOOTER //
// ./app/containers/student-roll/messages.js